import { render, staticRenderFns } from "./accountTab.vue?vue&type=template&id=a399ba54&scoped=true&"
import script from "./accountTab.vue?vue&type=script&lang=js&"
export * from "./accountTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a399ba54",
  null
  
)

export default component.exports